// @unocss-include

export const devPrompts = ['How do I center a div?', 'Build a todo app'];

export const examplePrompts = [
  { text: 'Create a financial app', href: '/~/financial-app', slug: 'financial-app' },
  { text: 'Design a directory website', href: '/~/directory-website', slug: 'directory-website' },
  { text: 'Build a project management app', href: '/~/app-project-management', slug: 'app-project-management' },
  { text: 'Make a landing page', href: '/~/payment-app', slug: 'payment-app' },
  { text: 'Generate a CRM', href: '/~/personal-crm', slug: 'personal-crm' },
];
